module.exports = __webpack_public_path__ + "img/exchange-2-zh-m.f64ca911.png";